var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.929,
    height: 68.237,
    viewBox: "0 0 101.929 68.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_554",
    x: 0,
    y: 0,
    width: 101.929,
    height: 68.237,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IOT",
    transform: "translate(-1269.289 -672.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(1278.333 678.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M43.2,19l.544.045,11.88.99,8.283,5.177,10.353-2.071,3.106,8.283,13.459-4.141L71.156,63.52,59.767,68.7,53.555,57.308,38.025,69.732,28.707,56.272,8,42.813l13.459-17.6,13.459-1.035Z",
    transform: "translate(-8 -19)",
    fill: "none",
    stroke: "#003063",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.04, -5.43)",
    filter: "url(#Path_554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554-2",
    "data-name": "Path 554",
    d: "M21.459,25.177l12.424,8.283,1.035-9.318L43.2,30.353,55.626,20l-17.6,49.7,25.883-44.52L8,42.777,77.368,31.389l-6.212,32.1-17.6-6.212L90.827,27.247,28.707,56.237l5.177-22.777L21.459,34.495l-4.47-3.472,1.99,18.892,14.9-16.455L43.2,30.353,42.166,43.813l22.777,4.141,9.318-24.848-1.035,31.06L59.767,68.661,54.59,48.989,30.777,46.919l17.6-8.283L23.53,44.848,39.06,51.06,38.025,69.7",
    transform: "translate(1.04 -13.53)",
    fill: "none",
    stroke: "#008578",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M2.079,0A2.079,2.079,0,0,1,3.346,3.728a2.04,2.04,0,0,1-1.267.43A2.079,2.079,0,0,1,2.079,0Z",
    transform: "translate(23.664 12.523)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1, -0.017, 0.017, 1, 62.288, 42.954)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(44.314 36.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(29.314 30.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 1.5,
    cy: 1,
    rx: 1.5,
    ry: 1,
    transform: "translate(19.314 35.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(63.314 33.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(10.314 29.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(22.314 26.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(14.314 24.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(12.314 14.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M1.04,0A1.04,1.04,0,1,1,0,1.04,1.04,1.04,0,0,1,1.04,0Z",
    transform: "translate(64.951 3.315)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(25.314 3.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(61.314 11.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(55.314 27.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    transform: "translate(65.314 21.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(66.314 18.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(59.314 16.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    transform: "translate(35.314 10.928)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(35.522 14.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M41,69.707a6.707,6.707,0,0,0,6.707,6.707V63A6.707,6.707,0,0,0,41,69.707Z",
    transform: "translate(-41 -63)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M51,63V76.414A6.707,6.707,0,1,0,51,63Z",
    transform: "translate(-44.293 -63)",
    fill: "#003063"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IoT-2",
    "data-name": "IoT",
    transform: "translate(38.19 23.415)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IoT"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1324.647 678.081)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1306.647 727.081)",
    fill: "#003063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M1.04,0A1.04,1.04,0,1,1,0,1.04,1.04,1.04,0,0,1,1.04,0Z",
    transform: "translate(1360.216 685.33)",
    fill: "#003063"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/IOT.ca3b03f378b1eb7742799ac4328c2442.svg";
export { ForwardRef as ReactComponent };